export default __webpack_public_path__ + "static/media/brioche_thumb.855cf6ff.jpg";